<template>
  <div  class="account">
    <div v-if="showIndex===0">
      <div  class="listItem">
        <div class="leftLabel">
          <img :src="sucessIcon" alt="">
          <div class="label">登录密码</div>
        </div>
        <div class="direction">
          <div class="text">互联网账号被盗风险，建议您定期更改密码以保护账户安全。</div>
          <div @click="showIndex = 1" class="actionBtn">修改</div>
        </div>
      </div>
      <div class="listItem">
        <div class="leftLabel">
          <img :src="sucessIcon" alt="">
          <div class="label">手机验证</div>
        </div>
        <div class="direction">
          <div class="text">您验证的手机：131****6285 若已丢失或停用，请立即更换，避免账户被盗。</div>
          <div @click="showIndex = 2" class="actionBtn">修改</div>
        </div>
      </div>
    </div>

    <update-password v-if="showIndex===1"></update-password>
    <update-phone-number v-if="showIndex===2"></update-phone-number>
  </div>

</template>

<script>
import sucessIcon from '@/assets/image/sucess.png'
import updatePassword from "./updatePassword";
import updatePhoneNumber from "./updatePhoneNumber";
export default {
  name: "index",
  components:{
    updatePassword,
    updatePhoneNumber
  },
  created() {
    if (this.$route.query.showIndex){
      this.showIndex = 0
    }
    },
  data() {
    return {
      sucessIcon,
      showIndex:0
    }
  },
}
</script>

<style lang="less" scoped>
.listItem{
  height: 110px;
  width: 100%;
  border-bottom: 1px solid #DCDCDC;
  display: flex;
  align-items: center;
  .leftLabel::before {
    content: '';
    position: absolute;
    top: 40px; /* 调整上部分边框的位置 */
    bottom: 40px; /* 调整下部分边框的位置 */
    right: 0;
    width: 1px;
    background-color: #cecece; /* 边框颜色 */
  }
  .leftLabel{
    width: 200px;
    height: 100%;
    display: flex;
    align-items: center;
    //border-right: 1px solid #cecece;
    //border-right-height: 0.5px;
    position: relative;
    border-right: 1px solid transparent; /* 透明边框 */
    img{
      //height: 48px;
      //width: 48px;
      //border: 1px solid red;
    }

    .label{
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 20px;
      color: #333333;
      margin-left: 19px;
    }
  }
  .direction{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 20px;
    //border: 1px solid red;
    width: 78%;
    overflow: hidden;
    .text{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 18px;
      color: #FF3535;
    }
    .actionBtn{
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 18px;
      color: #0058A6;
      cursor: pointer;
    }
  }
}
</style>